module.exports = __webpack_public_path__ + "static/media/guard_shield.e3a84090.png";